import {
  ProviderClient,
  ProviderClientAction,
  ProviderClientTrigger,
} from '../providers/abstract/provider.client'
import { CardAccountAuthorization } from './components/CardAccountAuthorization'
import { FormConnect } from './components/FormConnect'
import { FormSetup } from './components/FormSetup'
import { DataConnectorIcon } from './components/Icon'
import { InputsForm } from './components/InputsForm'
import { ProviderActionLabel } from './components/ProviderActionLabel'
import { ProviderLabel } from './components/ProviderLabel'
import { ProviderTriggerLabel } from './components/ProviderTriggerLabel'
import { SelectAccount } from './components/SelectAccount'
import { useAuthentication } from './hooks/useAuthentication'
import { useLabel } from './hooks/useLabel'
import { useProvider } from './hooks/useProvider'
import { useProviders } from './hooks/useProviders'

export const DataConnectorClient = {
  FormSetup,
  FormConnect,
  Icon: DataConnectorIcon,
  ProviderLabel,
  ProviderTriggerLabel,
  ProviderActionLabel,
  InputsForm,
  SelectAccount,
  CardAccountAuthorization,
  useLabel,
  useAuthentication,
  useProviders,
  useProvider,
}

export type DataConnectorProvider = ProviderClient
export type DataConnectorProviderTrigger = ProviderClientTrigger
export type DataConnectorProviderAction = ProviderClientAction
